export default "__VITE_ASSET__D4033H7t__"